<template>
    <div>
        <section class="signup_area">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="form-container d-flex">

                            <div class="form-wrap">
                                <div class="cardify signup_form">
                                    <div class="login--header pb-2">
                                        <h3>{{$store.getters.t('auth_forgot_title')}}</h3>
                                        <p>{{$store.getters.t('auth_forgot_enter_phone')}}</p>
                                        <div class="alert alert-danger mt-2 mb-0" role="alert" v-if="numberNotIsset">
                                            <span class="alert_icon lnr lnr-warning"></span>
                                            {{$store.getters.t('auth_forgot_number_not_found')}}
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                <span class="lnr lnr-cross" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                        <div class="alert alert-success mt-2 mb-0" role="alert" v-if="sendSuccess">
                                            <span class="alert_icon lnr lnr-checkmark-circle"></span>
                                            <strong>{{$store.getters.t('auth_forgot_success')}}</strong> {{$store.getters.t('auth_forgot_sms_sent')}}
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                                <span class="lnr lnr-cross" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </div>
                                    <!-- end .login_header -->

                                    <div class="login--form pt-0">

                                        <div class="form-group">
                                            <label for="phone">{{$store.getters.t('auth_forgot_phone_label')}}</label>
                                            <input id="phone" type="text" v-model="$v.formData.phone.$model" class="form-control" autocomplete="off" v-mask="'+1 (###) ###-####'" placeholder="+1 (999) 999-9999">
                                            <div class="field-error-text" v-if="$v.formData.phone.$error">{{$store.getters.t('common_invalid_field')}}</div>
                                        </div>

                                        <button class="btn btn--md btn--round register_btn" :disabled="$v.formData.$invalid" @click="sendNewPassword">{{$store.getters.t('auth_forgot_send')}}</button>

                                        <div class="login_assist">
                                            <p>{{$store.getters.t('auth_no_account')}} <a href="/auth/register">{{$store.getters.t('auth_register_now')}}</a>
                                            </p>
                                        </div>
                                    </div>
                                    <!-- end .login--form -->
                                </div>
                                <!-- end .cardify -->
                            </div>

                        </div>


                    </div>
                    <!-- end .col-md-6 -->
                </div>
                <!-- end .row -->
            </div>
            <!-- end .container -->
        </section>

    </div>
</template>

<script>
    import {mask} from 'vue-the-mask'
    import {helpers, required, minLength, maxLength, sameAs, between, email} from 'vuelidate/lib/validators';

    const phoneValidator = helpers.regex('phone', /^(?:\+1\s\(\d{3}\)\s[1-9]\d{2}-\d{2}-\d{2}|\+34\s[6789]\d{2}\s\d{3}\s\d{3})$/g);


    export default {
        directives: {mask},
        components:{
        },
        data(){
            return {
                appRoutes: null,
                phoneChangeControl: null,
                numberNotIsset: false,
                sendSuccess: false,
                formData: {
                    phone_stripped: null,
                    phone: null,
                },
            }
        },
        created() {
            this.appRoutes = window.appRoutes;
        },
        watch: {
            formData: {
                handler(val, oldVal) {
                    this.phoneChangeControl = val.phone;
                },
                deep: true
            },
            phoneChangeControl() {
                let self = this;
                self.formData.phone_stripped = self.formData.phone.replace(/(\s|-|\(|\))/gm, '');
            }
        },
        methods: {
            sendNewPassword(){
                let self = this;

                axios.post('/' + self.appRoutes['auth.forgot.sendNewPassword'], self.formData)
                    .then(response => {
                        response = response.data;
                        if (response.success) {
                            self.sendSuccess = true;
                        } else {
                            self.numberNotIsset = true;
                        }
                    })
                    .catch((error) => {

                    })
                    .then();
            }
        },
        validations: {
            formData: {
                phone: {
                    required,
                    phoneValidator
                },
            }

        }
    }
</script>
